module.exports = __webpack_public_path__ + "static/media/dem_pol_pus_arm.f4f3da16.png";